import React from 'react';
import styled from 'styled-components';

import BaseCard from '../BaseCard';
import Text from '../../Text';

const Card = styled(BaseCard)`
  width: 100%;
  padding: 32px 24px;
  flex: 1;
  ${({ theme }) => theme.breakpoint('md')} {
    flex: inherit;
    width: ${({ width }) => width || '400px'};
    border-radius: 6px;
    margin: 0 auto;
    padding: 32px;
  }
`;

const Title = styled(Text).attrs({ type: 'H6-w400' })`
  margin: 0;
`;

const Subtitle = styled(Text).attrs({ type: 'Subtitle-1-w400' })`
  color: var(--gray700);
  margin-top: 16px;
  margin-bottom: 0px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  ${({ theme }) => theme.breakpoint('md')} {
    padding-top: 32px;
  }
`;

const ScreenCard = ({ title, subtitle, children, isResetPass, titleId, ...props }) => (
  <Card {...props}>
    <Title
      id={titleId}
      style={{
        fontSize: isResetPass && '24px',
        fontWeight: isResetPass && '700',
        color: isResetPass && '#333333',
      }}
    >
      {title}
    </Title>
    {subtitle && (
      <Subtitle
        style={{
          fontSize: isResetPass && '16px',
          fontWeight: isResetPass && '400',
          color: isResetPass && '#333333',
          lineHeight: '18px',
        }}
      >
        {subtitle}
      </Subtitle>
    )}
    <Container>{children}</Container>
  </Card>
);

export default ScreenCard;
